import React from 'react';
import { motion } from 'framer-motion';
import { Card } from './ui/Card';
import { MoreHorizontal, Heart, MessageCircle, Share2, TrendingUp, ArrowUpRight, ArrowDownRight } from 'lucide-react';
const ads = [{
  id: 1,
  brand: 'TechFlow Systems',
  avatar: 'bg-blue-500',
  content: 'Scale your infrastructure automatically with our new cloud AI solutions. 🚀 #DevOps #Cloud',
  imageColor: 'bg-gradient-to-br from-blue-600 to-indigo-900',
  stats: {
    ctr: '2.4%',
    cpc: '1.2 PLN',
    roas: '4.2x'
  },
  trend: 'up'
}, {
  id: 2,
  brand: 'EcoLiving',
  avatar: 'bg-green-500',
  content: 'Sustainable furniture for the modern home. Spring sale starts now! 🌿',
  imageColor: 'bg-gradient-to-br from-emerald-600 to-teal-900',
  stats: {
    ctr: '3.1%',
    cpc: '0.8 PLN',
    roas: '5.8x'
  },
  trend: 'up'
}, {
  id: 3,
  brand: 'Urban Fit',
  avatar: 'bg-orange-500',
  content: 'Get fit, stay fit. Join the revolution today. #Fitness #Health',
  imageColor: 'bg-gradient-to-br from-orange-600 to-red-900',
  stats: {
    ctr: '1.8%',
    cpc: '2.1 PLN',
    roas: '2.1x'
  },
  trend: 'down'
}];
export function AdPreviewShowcase() {
  return <section id="showcase" className="py-24 bg-slate-900 relative overflow-hidden" data-id="element-9">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-10">
        <div className="text-center mb-16" data-id="element-11">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-12">
            Real-time Ad Optimization
          </h2>
          <p className="text-slate-400 max-w-2xl mx-auto" data-id="element-13">
            Our Sentinel Monitoring system analyzes creative performance across
            thousands of touchpoints to predict winners before you spend your
            budget.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-14">
          {ads.map((ad, index) => <motion.div key={ad.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} data-id="element-15">
              <Card className="h-full flex flex-col bg-slate-800 border-slate-700 hover:border-slate-600 transition-colors group" data-id="element-16">
                {/* Ad Header */}
                <div className="p-4 flex items-center justify-between border-b border-slate-700/50" data-id="element-17">
                  <div className="flex items-center gap-3" data-id="element-18">
                    <div className={`w-10 h-10 rounded-full ${ad.avatar} flex items-center justify-center text-white font-bold text-sm`} data-id="element-19">
                      {ad.brand[0]}
                    </div>
                    <div data-id="element-20">
                      <h4 className="text-sm font-semibold text-white" data-id="element-21">
                        {ad.brand}
                      </h4>
                      <p className="text-xs text-slate-400" data-id="element-22">Sponsored</p>
                    </div>
                  </div>
                  <MoreHorizontal className="text-slate-500 w-5 h-5" data-id="element-23" />
                </div>

                {/* Ad Content */}
                <div className="p-4 space-y-4 flex-1" data-id="element-24">
                  <p className="text-sm text-slate-300" data-id="element-25">{ad.content}</p>
                  <div className={`w-full aspect-video rounded-lg ${ad.imageColor} relative overflow-hidden group-hover:opacity-90 transition-opacity`} data-id="element-26">
                    <div className="absolute inset-0 flex items-center justify-center" data-id="element-27">
                      <span className="text-white/20 font-bold text-xl uppercase tracking-widest" data-id="element-28">
                        Ad Creative
                      </span>
                    </div>
                  </div>

                  {/* Social Actions Mockup */}
                  <div className="flex items-center justify-between text-slate-500 pt-2" data-id="element-29">
                    <div className="flex gap-4" data-id="element-30">
                      <Heart className="w-5 h-5" data-id="element-31" />
                      <MessageCircle className="w-5 h-5" data-id="element-32" />
                    </div>
                    <Share2 className="w-5 h-5" data-id="element-33" />
                  </div>
                </div>

                {/* Performance Footer */}
                <div className="bg-slate-900/50 p-4 border-t border-slate-700/50" data-id="element-34">
                  <div className="flex items-center justify-between mb-3" data-id="element-35">
                    <span className="text-xs font-medium text-slate-400 uppercase tracking-wider" data-id="element-36">
                      Performance Metrics
                    </span>
                    {ad.trend === 'up' ? <span className="flex items-center text-xs font-bold text-emerald-400 bg-emerald-400/10 px-2 py-1 rounded" data-id="element-37">
                        <ArrowUpRight className="w-3 h-3 mr-1" data-id="element-38" /> Trending
                      </span> : <span className="flex items-center text-xs font-bold text-amber-400 bg-amber-400/10 px-2 py-1 rounded" data-id="element-39">
                        <ArrowDownRight className="w-3 h-3 mr-1" data-id="element-40" /> Low Perf
                      </span>}
                  </div>

                  <div className="grid grid-cols-3 gap-2" data-id="element-41">
                    <div className="text-center p-2 rounded bg-slate-800" data-id="element-42">
                      <p className="text-[10px] text-slate-500 uppercase" data-id="element-43">
                        CTR
                      </p>
                      <p className="text-sm font-bold text-white" data-id="element-44">
                        {ad.stats.ctr}
                      </p>
                    </div>
                    <div className="text-center p-2 rounded bg-slate-800" data-id="element-45">
                      <p className="text-[10px] text-slate-500 uppercase" data-id="element-46">
                        CPC
                      </p>
                      <p className="text-sm font-bold text-white" data-id="element-47">
                        {ad.stats.cpc}
                      </p>
                    </div>
                    <div className="text-center p-2 rounded bg-slate-800" data-id="element-48">
                      <p className="text-[10px] text-slate-500 uppercase" data-id="element-49">
                        ROAS
                      </p>
                      <p className={`text-sm font-bold ${ad.trend === 'up' ? 'text-emerald-400' : 'text-amber-400'}`} data-id="element-50">
                        {ad.stats.roas}
                      </p>
                    </div>
                  </div>
                </div>
              </Card>
            </motion.div>)}
        </div>
      </div>
    </section>;
}